var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "productgrid--item imagestyle--natural" }, [
    _c("div", { staticClass: "productitem" }, [
      _c(
        "a",
        {
          staticClass: "productitem--image-link",
          attrs: { href: _vm.url, tabindex: "-1" }
        },
        [
          _c(
            "figure",
            { staticClass: "productitem--image", class: _vm.gridImageClass },
            [
              _c("img", {
                staticClass: "productitem--image-primary",
                attrs: {
                  src: _vm.sizedImageSrc,
                  alt: _vm.title,
                  srcset: _vm.sizedImageSrc + " 1x"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.displaySoldOut,
                      expression: "displaySoldOut"
                    }
                  ],
                  staticClass: "productitem--badge badge--soldout"
                },
                [
                  _vm._v(
                    "\n          " + _vm._s(_vm.soldOutLabel) + "\n        "
                  )
                ]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "productitem--info" }, [
        _c("h2", { staticClass: "productitem--title" }, [
          _c("a", { attrs: { href: _vm.url } }, [
            _vm._v("\n          " + _vm._s(_vm.title) + "\n        ")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "productitem--price" }, [
          _c("div", { staticClass: "price--main" }, [
            _c("span", {
              staticClass: "money",
              domProps: { innerHTML: _vm._s(_vm.price) }
            })
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }